import { render } from "./App.vue?vue&type=template&id=06d4b0de"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=06d4b0de&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ecommerce\\frontend_administrativo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__